import {FlatList, ListRenderItemInfo, Platform, Text, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import {StudentScheduleFormat} from 'stores/ClassStore';
import AnalyticsLessonCell from 'components/molecules/analyticsLessonItem';
import AnalyticsLessonListHeaderComponent from 'components/atoms/analyticsLessonListHeaderComponent';
import styleSheet from './styles';

export interface AnalyticsLessonListProps {
  data: StudentScheduleFormat[];
  onPress(
    id: string,
    title: string,
    classMarking: string,
    classDate: string,
    isRecordingNeeded: boolean,
  ): void;
  isRecordingRequest?: boolean;
  onGetRecordingButtonPressed?(value: string): void;
}

const AnalyticsLessonList = (props: AnalyticsLessonListProps) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  const renderItem = ({
    item,
    index,
  }: ListRenderItemInfo<StudentScheduleFormat>) => {
    return (
      <AnalyticsLessonCell
        index={index}
        subject={item.title}
        group={`${item.classMarking}`}
        time={`${item.scheduledTime}`}
        status={item.status}
        onPress={() =>
          props.onPress(
            item.sessionId,
            item.title,
            item.classMarking,
            item.classDate,
            item.isRecordingNeeded,
          )
        }
        isRecordingNeeded={item.isRecordingNeeded}
        isRecordingRequest={props.isRecordingRequest}
        onGetRecordingButtonPressed={() =>
          props.onGetRecordingButtonPressed?.(item.sessionId)
        }
      />
    );
  };

  return (
    <>
      {props.data?.length > 0 && (
        <FlatList
          data={props.data}
          renderItem={renderItem}
          ListHeaderComponent={
            Platform.OS !== 'web' ? null : AnalyticsLessonListHeaderComponent
          }
          style={styles.flatListStyle}
        />
      )}
    </>
  );
};

export default AnalyticsLessonList;
